import { FC } from "react";
import { useParams } from "react-router-dom";
import { useExportFileDownload } from "./useExportFileDownload";
import { Download } from "./Download";

export const ExportDownloads: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { url, isLoading } = useExportFileDownload(id!);

  return (
    <Download
      url={url}
      isLoading={isLoading}
      redirectToFile={(url) => {
        window.location.href = url;
      }}
    />
  );
};
